import router from "@/router";

export const API_HELPERS =  {
    contestId: import.meta.env.VITE_CONTEST_ID,
    scoreKey: 'Score',
    endpoints: {
        backendUrl: import.meta.env.VITE_BACKEND_URL,
        contest: {
            info: 'contest/{id}',
        },
        submission: {
            create: 'submission',
        },
        laureate: {
            info: 'laureate/{id}',
            save: 'laureate/{id}',
        },
        token: {
            get: 'getToken',
        },
        checkIp: {
            get: 'checkIpList/{id}'
        },
        ranking: {
            get: 'getRanking/{contest}/{key}'
        }
    }
}

export default class ApiHelper {
    static getContestInfoUrl() {
        let url =  API_HELPERS.endpoints.contest.info;
        url = url.replace('{id}', String(API_HELPERS.contestId));
        return API_HELPERS.endpoints.backendUrl + url;
    }

    static getSubmissionCreateUrl() {
        return API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.submission.create;
    }

    static getLaureateInfoUrl() {
        let url =  API_HELPERS.endpoints.laureate.info;
        url = url.replace('{id}', String(router.currentRoute.value.params.laureate));
        return API_HELPERS.endpoints.backendUrl + url;
    }

    static getLaureateSaveUrl() {
        let url =  API_HELPERS.endpoints.laureate.info;
        url = url.replace('{id}', String(router.currentRoute.value.params.laureate));
        return API_HELPERS.endpoints.backendUrl + url;
    }

    static getTokenUrl() {
        return API_HELPERS.endpoints.backendUrl + API_HELPERS.endpoints.token.get;
    }

    static checkIp() {
        let url =  API_HELPERS.endpoints.checkIp.get;
        url = url.replace('{id}', String(API_HELPERS.contestId));
        return API_HELPERS.endpoints.backendUrl + url;
    }

    static getRanking() {
        let url =  API_HELPERS.endpoints.ranking.get;
        url = url.replace('{contest}', String(API_HELPERS.contestId));
        url = url.replace('{key}', String(API_HELPERS.scoreKey));
        return API_HELPERS.endpoints.backendUrl + url;
    }
}

